import { __awaiter } from "tslib";
import { createNlsMiddleware, lccstate, userstate } from 'lcc-state';
import { publish, subscribe } from 'pub-sub';
import * as moment from 'moment';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, dom, v, w } from '@dojo/framework/core/vdom';
import Button from '@dojo/widgets/button';
import { convertToBoolean } from '@holmescorp/common';
import css from '../css/certificate.m.css';
import { check_rpc_passed, check_rpc_passed_date, load_cert, print_cert } from '../support/utils';
const factory = create({
    icache: createICacheMiddleware(),
    userstate,
    lccstate,
    theme,
    nls: createNlsMiddleware('certificate')
});
export const Certificate = factory(({ middleware: { icache, userstate, lccstate, theme, nls } }) => {
    const _canvas = document.createElement('canvas');
    const _printNode = document.createElement('iframe');
    let _certLoaded = false;
    const hasMetCriteria = icache.getOrSet('hasMetCriteria', false);
    const { isPlaceholder, messages } = nls();
    if (isPlaceholder) {
        return null;
    }
    const themedCss = theme.classes(css);
    const { get, path } = userstate;
    subscribe('cert/loaded', () => __awaiter(void 0, void 0, void 0, function* () {
        _certLoaded = true;
    }));
    const determine_eligibility = () => {
        if (hasMetCriteria) {
            return true;
        }
        const keyprops = () => {
            const { get, path } = lccstate;
            return {
                sitestatus: get(path('sitestatus'))
            };
        };
        const { sitestatus } = keyprops();
        const posttest = get(path('posttest'));
        const userid = get(path('user_id'));
        const { extra: exploreTool } = get(path('toolstate', 'explore'));
        const certificateAttested = exploreTool && exploreTool.certificateAttested;
        if ((posttest && posttest.passed) || certificateAttested) {
            icache.set('hasMetCriteria', true);
            return true;
        }
        else {
            check_rpc_passed(userid).then((earned) => {
                const eval_passed = convertToBoolean(messages.eval_required) ? sitestatus.eval_done : true;
                if (earned && eval_passed) {
                    icache.set('hasMetCriteria', true);
                    return true;
                }
                else {
                    return false;
                }
            });
            return false;
        }
    };
    const completed_date = icache.getOrSet('completed_date', () => __awaiter(void 0, void 0, void 0, function* () {
        const userid = get(path('user_id'));
        return yield check_rpc_passed_date(get(path('user_id')));
    }));
    const render_cert = () => {
        const printInstructions = messages.print_instructions || '';
        const printLabel = messages.print_label || '';
        const learnerName = get(path('fullname'));
        return [
            v('div', { classes: [themedCss.printInstructions], innerHTML: printInstructions }),
            v('div', { classes: [themedCss.printBtn] }, [
                w(Button, {
                    onClick: () => {
                        _certLoaded && print_cert();
                    },
                    focus: () => true
                }, [printLabel])
            ]),
            dom({ node: _canvas }),
            dom({
                node: _printNode,
                onAttach: () => load_cert({
                    messages,
                    learnerName,
                    completed_date: moment(completed_date).format('l'),
                    canvas: _canvas,
                    printNode: _printNode
                })
            })
        ];
    };
    const { unearned_instructions = '', eval_required = 'false', eval_btn_text = 'Complete Evaluation', eval_url = '' } = messages;
    const instructions = [
        v('div', { key: 'instructions-container' }, [
            v('p', { key: 'unearned-instructions', classes: [themedCss.unearnedInstructions] }, [
                unearned_instructions
            ]),
            eval_required === 'true'
                ? v('p', { key: 'evaluation-button' }, [
                    w(Button, {
                        onClick: () => {
                            if (eval_url) {
                                publish(`site${eval_url}`);
                            }
                        }
                    }, [eval_btn_text])
                ])
                : null
        ])
    ];
    return v('div', { classes: [themedCss.root] }, !determine_eligibility() ? instructions : render_cert());
});
